<template>
  <div>
    详情
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
export default {
  data() {
    return {
      
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {}
}
</script>